/**
 * Normaliza texto para comparação: remove acentos (NFD), apara espaços
 * e converte para maiúsculas.
 *
 * @example
 * normalizarTextoComparacao(" São Paulo ") -> "SAO PAULO"
 * normalizarTextoComparacao("café") -> "CAFE"
 */
export function normalizarTextoComparacao(texto: string | null | undefined): string {
  if (texto == null || texto === "") {
    return "";
  }

  return texto
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase();
}
